/**
 * @generated SignedSource<<058f9f6a726b07cdade278af2d58717a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PriceInfo_component$data = {
  readonly archive: {
    readonly " $fragmentSpreads": FragmentRefs<"SimpleLink_simpleLink">;
  } | null | undefined;
  readonly checked: boolean;
  readonly file: {
    readonly " $fragmentSpreads": FragmentRefs<"FileLink_fileLink">;
  } | null | undefined;
  readonly tableheader: ReadonlyArray<{
    readonly col: string | null | undefined;
    readonly label: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "PriceInfo_component";
};
export type PriceInfo_component$key = {
  readonly " $data"?: PriceInfo_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"PriceInfo_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PriceInfo_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TableHeader",
      "kind": "LinkedField",
      "name": "tableheader",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "col",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FileLink",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FileLink_fileLink"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SimpleLink",
      "kind": "LinkedField",
      "name": "archive",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SimpleLink_simpleLink"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checked",
      "storageKey": null
    }
  ],
  "type": "PriceInfo",
  "abstractKey": null
};

(node as any).hash = "fc7ecf089a533c9af00423590d52134e";

export default node;
